import { render } from "./PopUpModal.vue?vue&type=template&id=18ee46b5&scoped=true"
import script from "./PopUpModal.vue?vue&type=script&lang=js"
export * from "./PopUpModal.vue?vue&type=script&lang=js"

import "./PopUpModal.vue?vue&type=style&index=0&id=18ee46b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ee46b5"]])

export default __exports__